import type { ChatMessage } from "../../data/types/chat";
import { LandingChatTranscript } from "../../../landing/presentation/components/landing-chat-transcript";

interface AiChatPanelProps {
  /** Whether the panel should be visible (chat is active). */
  visible: boolean;
  /** True when the viewer is signed in — affects auth-gated affordances. */
  loggedIn: boolean;
  transcript: ChatMessage[];
  responding: boolean;
  onAuthRequired: () => void;
  onRetry?: (() => void) | null;
  onSendMessage?: (text: string, productId?: number) => void;
}

/**
 * Shared chat takeover panel rendered identically on the public landing
 * (`/`) and the authenticated AI search page (`/ai-search`). Layout, scroll
 * behavior, and styling all live in `landing-page.css` under `#rpPanel` —
 * the only thing that changes between flows is the `loggedIn` prop.
 */
export function AiChatPanel({
  visible,
  loggedIn: _loggedIn,
  transcript,
  responding,
  onAuthRequired: _onAuthRequired,
  onRetry,
  onSendMessage,
}: AiChatPanelProps) {
  return (
    <div id="rpPanel" className={visible ? "rp-visible" : ""}>
      {visible && (
        <LandingChatTranscript transcript={transcript} responding={responding} onRetry={onRetry} onSendMessage={onSendMessage} />
      )}
    </div>
  );
}
